export const MOCK = [
  {
    vehicle: {
      id: 'encoded',
      type: {
        name: 'Carreta',
      },
      body: {
        name: 'Baú',
      },
    },
    person: {
      id: '84b',
      uuid: '966c4e36-b16f-49aa-8ca2-b004d9c91d68',
      name: 'Ronaldinho Gaúcho',
      areaCodes: [19],
    },
    refundableFare: {
      paidAt: '00/00/00 as 12:00',
    },
  },
  {
    vehicle: {
      id: 'encoded2',
      type: {
        name: 'Van',
      },
      body: {
        name: 'Furgão',
      },
    },
    person: {
      id: '92b',
      uuid: '4f8e7b12-3a6d-4e54-a4d1-8e4b9d9dc6b2',
      name: 'Neymar Jr.',
      areaCodes: [11, 13, 47],
    },
    refundableFare: {
      paidAt: '01/01/01 as 12:00',
    },
  },
  {
    vehicle: {
      id: 'decoded',
      type: {
        name: 'Caminhão',
      },
      body: {
        name: 'Cegonha',
      },
    },
    person: {
      id: '92c',
      uuid: '7a1e60c4-4827-4e70-a3a9-f6829a123456',
      name: 'Ronaldo Fenômeno',
      areaCodes: [11],
    },
    refundableFare: {
      paidAt: '01/01/01 às 13:00',
    },
  },
  {
    vehicle: {
      id: 'decoded',
      type: {
        name: 'Carreta',
      },
      body: {
        name: 'Bau',
      },
    },
    person: {
      id: 'a12c',
      uuid: '7d8e2b41-3f6a-4e2b-b2a1-9f3c1d6e94ee',
      name: 'Kylian Mbappe',
      areaCodes: [22, 35, 47],
    },
    refundableFare: {
      paidAt: '01/01/24 as 09:30',
    },
  },
  {
    vehicle: {
      id: 'encoded_2',
      type: {
        name: 'Van',
      },
      body: {
        name: 'Furgão',
      },
    },
    person: {
      id: '29c',
      uuid: '72e6f93a-8b78-4a67-a619-8d9f34a7d402',
      name: 'Ricardo Izecson (Kaka)',
      areaCodes: [11, 13, 47],
    },
    refundableFare: {
      paidAt: '01/01/01 as 08:00',
    },
  },
  {
    vehicle: {
      id: 'decoded1',
      type: {
        name: 'Carro',
      },
      body: {
        name: 'Sedan',
      },
    },
    person: {
      id: 'c5a',
      uuid: 'af19f58d-37ef-4f08-8a6f-21d4f1a54d7c',
      name: 'Erling Haaland',
      areaCodes: [10],
    },
    refundableFare: {
      paidAt: '01/01/01 às 10:10',
    },
  },
  {
    vehicle: {
      id: 'decoded2',
      type: {
        name: 'Caminhão',
      },
      body: {
        name: 'Reboque',
      },
    },
    person: {
      id: 'f7b',
      uuid: '5b38811f-ef9b-4547-8740-d5413d9c0c7f',
      name: 'Cristiano Ronaldo',
      areaCodes: [22, 23, 24],
    },
    refundableFare: {
      paidAt: '02/02/02 às 11:11',
    },
  },
];

export const skeletonRefundableListIndexMock = [
  'skeleton-9f5e5b29-9d2b-4e7b-b9c5-8a504f7f169a',
  'skeleton-2a9a8e66-881f-4326-b83f-5c1f6eb89d2e',
  'skeleton-8c7a7d02-7df7-4da7-b547-1a34605f1f6b',
  'skeleton-d057b68e-8f71-452e-a3ed-769ddc4e23f4',
  'skeleton-32b6e2e4-8e9d-432d-9e68-bccaa1d013dc',
  'skeleton-b79e734f-11db-4a1b-86d7-ff0a1e7e3965',
];
